import { Receipt } from '@/entities/receipt'
import { DisputModel } from '@/features/orders/model/types'
import { formatDate } from '@/shared/lib/date'

export const OrderBanner = ({ disput }: { disput: DisputModel }) => {
  const columnClasses =
    'flex flex-col flex-1 border-r last:border-0 border-r-card-border dark:border-r-card-border-dark pl-6 first:pl-0 pr-6 last:pr-0'

  const InfoColumn = ({ label, value }: { label: string; value: string | React.ReactNode }) => (
    <div className={`${columnClasses}`}>
      <div className="flex flex-col">
        <span className="text-text-secondary text-sm">{label}</span>
        <span className="font-medium">{value || ''}</span>
      </div>
    </div>
  )

  return (
    <div className="flex bg-light-purple dark:bg-dark-purple p-6 rounded-2xl">
      <div className={columnClasses}>
        <Receipt receiptFile={disput.receiptFile} receiptType={disput.receiptType} />
      </div>
      <InfoColumn label="Дата создания" value={formatDate(disput.createdAt, 'long', {})} />
      <InfoColumn
        label="Информация об ордере"
        value={disput.description ? disput.description : 'Нет данных'}
      />
    </div>
  )
}
